import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { CTASection } from "../components/CTASection";
import { Construction, ArrowUpRight } from "lucide-react";

export default function Projects() {
  return (
    <>
      <PageHeader
        eyebrow="Projeler & Referanslar"
        titleLines={["Yakında", "burada."]}
        description="İlk kurulumlarımızı tamamladıkça sahadan gerçek referanslarımızı; güç değerleri ve konumlarıyla birlikte bu sayfada paylaşacağız."
      />

      <section data-testid="projects-coming-soon" className="relative bg-[#0A0A0A] pb-24 sm:pb-32">
        <div className="max-w-[1100px] mx-auto px-5 sm:px-8">
          <Reveal>
            <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-[#121212] px-6 sm:px-8 py-20 sm:py-28 text-center">
              <div className="absolute inset-0 grid-lines opacity-30" />
              <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[420px] h-[420px] bg-[#5CC528]/10 rounded-full blur-[120px]" />
              <div className="relative">
                <motion.div
                  initial={{ scale: 0.85, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                  className="mx-auto mb-8 w-20 h-20 rounded-2xl bg-[#5CC528]/15 flex items-center justify-center"
                >
                  <Construction size={34} className="text-[#5CC528]" />
                </motion.div>
                <span className="inline-block px-4 py-1.5 rounded-full bg-[#5CC528] text-black text-xs font-bold uppercase tracking-[0.2em] mb-6">
                  Yakında
                </span>
                <h2 className="font-display font-light text-3xl sm:text-5xl tracking-tighter text-white leading-[1.05]">
                  Projelerimizi <span className="text-[#5CC528]">çok yakında</span><br className="hidden sm:block" /> burada yayınlayacağız.
                </h2>
                <p className="mt-6 text-neutral-400 max-w-xl mx-auto leading-relaxed">
                  Şu anda ilk kurulumlarımız üzerinde çalışıyoruz. Tamamlanan çatı, arazi ve tarımsal sulama
                  GES projelerimizi güç değerleri ve konumlarıyla kısa süre içinde bu sayfada göreceksiniz.
                </p>
                <Link
                  to="/iletisim"
                  data-testid="projects-contact-btn"
                  className="inline-flex items-center gap-2 mt-10 bg-[#5CC528] text-black font-semibold px-8 py-4 rounded-full hover:bg-[#4AA020] transition-colors duration-200"
                >
                  Projeniz için teklif alın <ArrowUpRight size={18} />
                </Link>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <CTASection />
    </>
  );
}
